import { useEffect } from "react";
import { Box, CircularProgress, Grid, Typography } from "@mui/material"; 
import AeropayTxTable from "../components/AeropayTxTable";
import AeropayTxFilters from "../components/AeropayTxFilters";
import BackButton from "../../../../../components/shared/Buttons/BackButton";
import useAeropayTransactions from "../hooks/useAeropayTransactions";

export default function ViewAeropayTxPage() {
  const {
    rows,
    hasNext,
    loading,
    exportLoading,

    page,
    rowsPerPage,
    paginationCount,

    startDate,
    endDate,
    setStartDate,
    setEndDate,

    fetchPage,
    onFilter,
    onExport,
    onChangePage,
    onChangeRowsPerPage,
  } = useAeropayTransactions();

 
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress size={50} />
      </Box>
    );
  }

  return (
    <Box m={3}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <BackButton pageTitle="View Aeropay Transactions" />
        </Grid>

        <Grid item xs={12}>
          <AeropayTxFilters
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            loading={loading}
            exportLoading={exportLoading}
            onFilter={onFilter}
            onExport={onExport}
          />
        </Grid>

        <Grid item xs={12}>
          {!rows.length ? (
            <Typography color="text.secondary">No AeroPay transactions found.</Typography>
          ) : (
            <AeropayTxTable
              rows={rows}
              hasNext={hasNext}
              page={page}
              rowsPerPage={rowsPerPage}
              paginationCount={paginationCount}
              onChangePage={onChangePage}
              onChangeRowsPerPage={onChangeRowsPerPage}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
